import * as React from 'react';
import Colors from '../../constants/Colors';
import { CoinProps } from '../../data/coinPrices';
import styled from 'styled-components';
import BigNumber from 'bignumber.js';
import * as numeral from 'numeral';
import { PFBalanceProps } from '../../data/portfolioData';

const Item = styled.div`
  display: grid;
  grid-template-columns: 160px 160px;
  background: ${Colors.darkSteel};
`;

const Left = styled.div`
  padding: 4px;
`;

const Right = styled.div`
  padding: 4px;
`;

const Symbol = styled.div`
  display: inline-block;
  color: #fff;
  font-size: 14px;
`;

const USDValue = styled.div`
  color: #fff;
  font-size: 18px;
  padding-top: 3px;
`;

const StatLabel = styled.div`
  color: #ccc;
  display: inline;
  padding-right: 5px;
  font-size: 12px;
`;

const StatValue = styled.div`
  color: #fff;
  display: inline;
  font-size: 12px;
`;

const DiffPercent = styled<{ value: number }, 'span'>('span')`
  color: ${props => (+props.value >= 0 ? Colors.statGreen : Colors.statRed)};
  font-size: 13px;
`;

const DiffValue = styled<{ value: number }, 'span'>('span')`
  color: ${props => (+props.value >= 0 ? Colors.statGreen : Colors.statRed)};
  font-size: 13px;
`;

type DiffProps = {
  diff: number;
  diffAmount: string;
};

const Diff: React.SFC<DiffProps> = ({ diff, diffAmount }) => (
  <div>
    <DiffPercent value={diff}>{diff > 0 ? '+' : ''}</DiffPercent>
    <DiffValue value={diff}>{diffAmount}</DiffValue>
  </div>
);

type StatProps = {
  label: string;
  value: string;
};

const Stat: React.SFC<StatProps> = ({ label, value }) => (
  <div>
    <StatLabel>{label}</StatLabel>
    <StatValue>{value}</StatValue>
  </div>
);

type Props = {
  balance: PFBalanceProps;
  coin: CoinProps;
};

const CoinImage = styled.img`
  width: 16px;
  height: 16px;
  display: inline-block;
`;

const PFBalance: React.SFC<Props> = ({ balance, coin }) => {
  const btcValue = 7052.45;
  const priceUSD = new BigNumber(balance.amount).times(coin.quotes.btc.price).times(btcValue);
  const priceUSDFmt = numeral(priceUSD).format('$0,0.00');
  const currPrice = coin.quotes.btc.price.toFixed(8);
  const amount = balance.amount.toString();
  const avgPrice = balance.price.toString();
  const diff = coin.quotes.btc.price / balance.price - 1;
  const diffAmount = numeral(diff).format('%0');
  const imgUrl = 'https://s3.amazonaws.com/assets.coinmend.com/images/coins';
  const logoUrl = `${imgUrl}/32x32/${balance.coinId}.png`;
  return (
    <Item>
      <Left>
        <Symbol>
          <CoinImage src={logoUrl} alt="" /> {coin.symbol}
        </Symbol>
        <USDValue>{priceUSDFmt}</USDValue>
        <Diff diff={diff} diffAmount={diffAmount} />
      </Left>
      <Right>
        <Stat label="Avg. Price:" value={avgPrice} />
        <Stat label="Curr. Price:" value={currPrice} />
        <Stat label="Amount" value={amount} />
      </Right>
    </Item>
  );
};

export default PFBalance;



// WEBPACK FOOTER //
// ./src/containers/Portfolio/PFBalance.tsx